<template>
  <div>
    <rui-loading v-if="loading" :text="$t('generic.loading')" />
    <rui-alert v-else-if="loadingError" variant="danger" centered>
      <p>{{ $t('js.generic.loading_data_error') }}</p>
      <rui-button :disabled="loading" @click="loadObservations">{{ $t('js.generic.retry') }}</rui-button>
    </rui-alert>
    <rui-empty v-else-if="observations.length === 0" :content="$t('js.elements.observations.no_observation')">
      <template #actions>
        <rui-button v-if="editable"
                    icon="plus"
                    :caption="$t('js.elements.observations.new_observation')"
                    variant="creative"
                    @click="$emitBus('show-observation-form', subject)" />
      </template>
    </rui-empty>
    <template v-else>
      <div v-if="editable" class="-pd -bb -text--right">
        <rui-button icon="plus"
                    :caption="$t('js.elements.observations.new_observation')"
                    variant="creative"
                    @click="$emitBus('show-observation-form', subject)" />
      </div>

      <gp-observation v-for="observation in observations"
                      :key="observation.id"
                      :observation="observation" />
    </template>
  </div>
</template>

<script>
import RuiAlert from '@experiments-labs/rise_ui/src/components/Alert/Alert.vue'
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiEmpty from '@experiments-labs/rise_ui/src/components/DataDisplay/Empty/Empty.vue'
import RuiLoading from '@experiments-labs/rise_ui/src/components/Loading/Loading.vue'

import Element from '../../../../classes/models/Element'
import Map from '../../../../classes/models/Map'
import Patch from '../../../../classes/models/Patch'
import Path from '../../../../classes/models/Path'

import GpObservation from '../../../../common/DataDisplay/Observation/Observation.vue'

export default {
  name: 'GpaObservations',
  components: { RuiEmpty, RuiButton, RuiAlert, RuiLoading, GpObservation },
  props: {
    subject: { required: true, type: [Element, Map, Patch, Path] },
    editable: { required: false, type: Boolean, default: false },
  },
  data () {
    return {
      loadingError: true,
      loading: false,
    }
  },
  computed: {
    observations () {
      return this.$store.getters.observationsBySubject(this.$props.subject)
    },
  },
  methods: {
    loadObservations () {
      this.loading = true
      this.loadingError = false
      this.$store.dispatch('loadObservationsBySubject', this.$props.subject)
        .catch(() => { this.loadingError = true })
        .then(() => { this.loading = false })
    },
  },
  created () { this.loadObservations() },
}
</script>
